export const updatePassword = {
  'Update password': 'Actualizar contraseña',
  'Create a new password to complete <2>access to your account.</2>':
    'Cree una nueva contraseña para completar el <2>acceso a su cuenta.</2>',
  'You only have {{time}} to register your new password.':
    'Tiene solo {{time}} para registrar su nueva contraseña.',

  'You must provide a password following all the requirements bellow':
    'Debe ingresar una contraseña que cumpla con todos los requisitos a continuación',
  'The passwords are not the same': 'Las contraseñas no son las mismas',
  'You must provide a password': 'Debes ingresar una contraseña',

  'It must contain at least 8 characters':
    'Debe contener al menos 8 caracteres',
  'It must contain at least one lower case letter':
    'Debe contener al menos una letra minúscula',
  'It must contain at least one upper case letter':
    'Debe contener al menos una letra mayúscula',
  'It must contain at least one number': 'Debe contener al menos un número',
  'It must contain at least one special character':
    'Debe contener al menos un carácter especial',

  'Success!': 'Éxito!',
  'Your password was updated successfully! Now you can login into your customer area with the new password created':
    'Su contraseña ha sido actualizada exitosamente! Ya puedes iniciar sesión en tu área de cliente con tu nueva contraseña creada.',
  'Go home': 'Ir al inicio',
  Login: 'Acceso',

  'Password reset unavailable!':
    '¡Restablecimiento de contraseña no disponible!',
  'This password reset is unavailable. Please, request a new code to continue':
    'Este restablecimiento de contraseña no está disponible. Solicite un nuevo código',

  'Reset expired password!': '¡Restablecimiento de contraseña expirado!',
  'This password reset is expired. Please, request a new code to continue':
    'El tiempo para cambiar su contraseña ha expirado. Solicite un nuevo código para continuar',
};
